<template>
    <div>
<!--        nihao111-->
        <router-view></router-view>
    </div>

</template>

<script>
    export default {
        name: "smartCanteen",
        methods:{

        }
    }
</script>

<style>

</style>